<template lang="pug">
.card.market-card
  .card-header.bg-more-head.collapse-more(
    :id="'heading-htftoe-' + id"
    data-toggle='collapse'
    :data-target="'#collapse-htftoe-' + id"
    :aria-controls="'collapse-htftoe-' + id"
    aria-expanded=true
  )
    .flex-grow-1.text-ellipsis.text-uppercase.mr-2 {{ $t("m.BT_HTFTOE") }}
  .collapse.show(
    :aria-labelledby="'heading-htftoe-' + id"
    :id="'collapse-htftoe-' + id"
  )
    .card-body.p-0
      .market-card-content
        .normal(v-if="mode == 0 || mode == 1")
          .normal-title {{ $t("ui.full_time") }}
          .normal-odd-area
            .normal-odd-area-group(v-for="item in col")
              .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.BK_" + item) }}
              template(v-if="moreItems['htftoeo'][item] && moreItems['htftoeo'][item][5] != 0 && moreItems['htftoeo'][item][5] != ''")
                OddsItem(:odds="moreItems['htftoeo'][item]" idx=5 :typ="oddsType" dataType="3" :details="moreItems" mode="htftoeo")
              template(v-else)
                OddsDisabled
</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    OddsItem,
    OddsDisabled
  },
  mixins: [mixinHDPOUOdds],
  props: {
    mode: {
      type: Number
    }
  },
  data() {
    return {
      col: ["OO", "OE", "EO", "EE"],
    }
  }
}
</script>